import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as badgeDisplay from "../fragments/badge/displayFragments";
import * as courseActionFragments from "../fragments/course/actionFragments";
import * as courseDisplay from "../fragments/course/displayFragments";
import * as programDisplay from "../fragments/program/displayFragments";
import * as trackDisplay from "../fragments/programTrack/displayFragments";
import * as trackProductDisplayFragments from "../fragments/trackProduct/displayFragments";

const programDisplayField = FragmentProvider.getLayoutInput(programDisplay);
const trackDisplayField = FragmentProvider.getLayoutInput(trackDisplay);

const trackProductFragments = {
	...courseDisplay,
	...courseActionFragments,
	...trackProductDisplayFragments
};

const testFragments = {
	...courseDisplay,
	...courseActionFragments
};

const courseDisplayField = FragmentProvider.getLayoutInput(trackProductFragments);

const testDisplayField = FragmentProvider.getLayoutInput(testFragments);

const badgeDisplayField = FragmentProvider.getLayoutInput(badgeDisplay);

// tslint:disable:max-classes-per-file

@Entity({one: "program", many: "programs"})
class Program {

	@Field()
	public id: any;

	@Field()
	public name: string;

}

const programSelect = EntitySelect.registered({
	entity: Program,
	type: 'one'
}, 'string');

const tempCourseListViewSelect = ButtonSelect.registerWithOptions([
	{value: undefined, label: 'List'},
	{value: 'rows', label: 'Rows'},
	{value: 'accordion', label: 'Accordion'}
]);

@Form({title: "Program Details Panel Config"})
export default class ProgramDetailsPanelConfig {

	@Input({type: programSelect, title: "Selected Program", description: "panel will look for page parameters if no program specified"})
	public programId: ID;

	@Input({type: InputType.CHECKBOX, title: "Enable Language Support"})
	public enableLanguageSupport: boolean;

	@Input({type: programDisplayField, title: "Program Layout"})
	public programLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: trackDisplayField, title: "Program Track Layout"})
	public trackLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: testDisplayField, title: "Pre Test Layout"})
	public preTestLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: testDisplayField, title: "Post Test Layout"})
	public postTestLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: courseDisplayField, title: "Track Course Layout"})
	public courseLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: courseDisplayField, title: "Track Course Expanded View Layout"})
	public courseExpandLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: badgeDisplayField, title: "Badge Layout"})
	public badgeLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: tempCourseListViewSelect, title: "Course List Type"})
	public courseListFragment: string;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/config/ProgramDetailsPanelConfig.ts